"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function convertTimeSeriesToApexData(series) {
    return series.map(function (series) {
        return {
            name: series.name,
            data: series.data.map(function (datum) { return [datum.timestamp, datum.value]; }),
            type: series.type,
        };
    });
}
exports.convertTimeSeriesToApexData = convertTimeSeriesToApexData;
function convertCategorySeriesToApexData(series) {
    return series.map(function (series) {
        return {
            name: series.name,
            data: series.data,
            type: series.type,
        };
    });
}
exports.convertCategorySeriesToApexData = convertCategorySeriesToApexData;
